import { render } from "./BaugrundstueckStep5b.vue?vue&type=template&id=1bf0b4ca"
import script from "./BaugrundstueckStep5b.vue?vue&type=script&lang=js"
export * from "./BaugrundstueckStep5b.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__